<template>
	<div class="face_track">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">视频人脸检测与跟踪</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对视频流的BGR24数据进行人脸检测、跟踪。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (void)skFaceVideoTrack:(unsigned char *)pBGR24
faceDetectCallback:(void (^)(struct FaceStruct* faceStruct, int 
retCount))faceDetectCallback;
</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pBGR24：视频帧的bgr倒立数据</p>
        <p class="doc_main_p">（2）faceDetectCallback(FaceStruct* faceStruct, int retCount): 人脸检测结果回调</p>
        <p class="doc_main_p">（3）faceStruct检测结果结构体数组，retCount人脸个数</p>
        <h3 class="doc_main_h3">回调值</h3>
        <p class="doc_main_p">数据结构（数组）（返回结构体指针，里面有retCount个FaceStruct结构体）
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">[SKFaceManagerInterface skFaceVideoTrack:pBGR24 faceDetectCallback:
^(struct FaceStruct *faceStruct, int retCount) 
	{	
       	  //这里对回调数据进行处理
          //这样就可以取到当前视频帧中的第一个人脸的检测数据
          FaceStruct firstFaceStruct = faceStruct[0];
	}
];</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
					isPathData:['人脸识别','SKFace-iOS','基础接口','视频人脸检测与跟踪'],
				  }
			  },
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.face_track{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfaceios/basics/faceTrack.vue